.root {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.top {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.mentionList {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.favorite {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.cover {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 15%;
  min-width: 190px;
  margin-left: auto;
  margin-left: 3.5rem;
}

.share {
  margin-top: 0.5rem;
}

.inner {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.footer {
  margin-top: auto;
}
